import { mdiGlassCocktail } from '@mdi/js'
import Icon from '@mdi/react'

const GlassCocktail = (props) => (
    <Icon
        data-testid="IconButton__GlassCocktail"
        path={mdiGlassCocktail}
        size={1}
        {...props}
    />
)

export default GlassCocktail
